import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { OtpGenerationComponent } from './otp-generation/otp-generation.component';
import { TripDetailsComponent } from './trip-details/trip-details.component';
import { ObservationVerificationComponent } from './observation-verification/observation-verification.component';
import { HistoricEpodComponent } from './historic-epod/historic-epod.component';
import { EpodComponent } from './epod/epod.component';
import { LrVerificationComponent } from './lr-verification/lr-verification.component';
import { LrDetailsComponent } from './lr-details/lr-details.component';
const routes: Routes = [
  { path: 'lorry-receipt/:id/unloading-form', component: OtpGenerationComponent },
  { path: 'indent-destination/:id/observation', component: OtpGenerationComponent },
  { path: 'lorry-receipt/details/:type/:id/:phNo/:otp', component: TripDetailsComponent },
  { path: 'ob', component: ObservationVerificationComponent },
  { path: 'historic-epod', component: HistoricEpodComponent },
  { path: 'epod', component: EpodComponent },
  { path: 'lr', component: LrVerificationComponent },
  { path: 'lr-details', component: LrDetailsComponent },
 
  { path: '', redirectTo: 'lorry-receipt/:id/unloading-form', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    preloadingStrategy :PreloadAllModules
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }